import { render, staticRenderFns } from "./NosotrosMaxica.vue?vue&type=template&id=6765796c&scoped=true"
import script from "./NosotrosMaxica.vue?vue&type=script&lang=js"
export * from "./NosotrosMaxica.vue?vue&type=script&lang=js"
import style0 from "./NosotrosMaxica.vue?vue&type=style&index=0&id=6765796c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6765796c",
  null
  
)

export default component.exports